import { useParams } from "react-router-dom";
import { useUserDetail } from "./use-user-detail";
import { UserDetailError, UserDetailLoading } from "./detail/UserDetailStates";
import { UserDetailBody } from "./detail/UserDetailBody";

export function UserDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data: user, isLoading, isError, error } = useUserDetail(id);

  if (isLoading) return <UserDetailLoading />;
  if (isError) return <UserDetailError error={error} />;
  if (!user) return null;

  // Keyed by user id: navigating to another user remounts the whole body, so
  // no per-user state (open dialogs, toast, section selections) survives into
  // the next user. One key here instead of one per section, so a new sibling
  // can never reintroduce a duplicate key.
  return <UserDetailBody key={user.id} user={user} />;
}
